<template>
  <div>
    <!-- <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                @addForm="addForm"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="6">
              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Nama Admin"
                    invalid-feedback="Nama Admin should be filled"
                    required
                    v-model="$v.administratorForm.name.$model"
                    :is-valid="!$v.administratorForm.name.$invalid"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Email"
                    type="Email"
                    invalid-feedback="Email should be filled"
                    required
                    v-model="$v.administratorForm.email.$model"
                    :is-valid="!$v.administratorForm.email.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <CInput
                    type="password"
                    label="Password"
                    invalid-feedback="Password should be filled"
                    required
                    v-model="$v.administratorForm.password.$model"
                    :is-valid="!$v.administratorForm.password.$invalid"
                    was-validated
                  />
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.administratorForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "@/templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

export default {
  name: "Administrator",
  components: { Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "Administrator",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "admin_code", type: "string" },
          { name: "name", type: "string" },
          { name: "email", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "admin_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Administrator Code",
        },
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Name",
        },
        {
          datafield: "email",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Email",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      items: null,
      administratorForm: tableInterfaces.administrator,
      isLoading: false,
      addButton: false,
      isEdit: false,

      showNeed:false,
      exportNeed:false,

      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    administratorForm: {
      admin_code: {},
      name: { required },
      email: { required },
      password: { required },
    }
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.getAdministrator();
      this.isEdit = false;
      this.cancelForm();
    },
    getAdministrator: function () {
      this.isLoading = true;
      this.axios
        .get("console/administrator/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.administrator) {
        tableInterfaces.administrator[i] = null;
      }
      this.administratorForm = tableInterfaces.administrator;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this freezer ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/administrator/add", this.administratorForm)
          .then((response) => {
            // console.log(response)
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              // this.$router.push({
              //   path: path[2] + "/detail/" + response.data.id,
              // });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>